module.exports = __webpack_public_path__ + "7b7cad0428f1d2741a2e0e98e4a60506.pdf";